module.exports = "<app-header></app-header>\n<h1>Oups...</h1>\n<br/>\n<br/>\n<br/>\n<br/>\n<p class=\"text-center\">Cette page n'existe pas :(</p>\n<app-footer style=\"position: absolute; bottom: 0px;\"></app-footer>"


//////////////////
// WEBPACK FOOTER
// /Users/enzo/Desktop/capsycofr-angular/src/app/pages/404/404.component.html
// module id = ../../../../../src/app/pages/404/404.component.html
// module chunks = main